import {Component, OnInit} from '@angular/core';
import { AppService } from '../shared/services/app.service';
import { MaterialsService } from './materials.service';
import { NotifyService } from '../shared/services/notify.service';

@Component({
  selector: 'app-materials',
  templateUrl: './materials.component.html',
  styleUrls: ['./materials.component.css']
})
export class MaterialsComponent implements OnInit {

  materials:any[] = [];
  newMat:string = null;
  newColor:any = {};

  constructor(
    private _appService: AppService,
    private _matService: MaterialsService,
    private _notifyService: NotifyService
  ) { }

  ngOnInit() {
    this.getMaterials();
  }

  private getMaterials() {
    this._matService.getMaterials().subscribe(
      data => {
        this.materials = data.materials;
        this._appService.hideLoader();
      }
    );
  }

  deleteMat(mat, i) {
    this._appService.showLoader();
    this._matService.delMat(mat).subscribe(
      data => {
        this.materials.splice(i, 1);
        setTimeout(()=> {
          this._notifyService.setNote({
            styleClass: 'alert-success',
            heading: 'Success!',
            body: 'Material Deleted'
          });
          this._appService.hideLoader();
        }, 1000);
      }
    );
  }

  delColor(mat, i, color) {
    this._appService.showLoader();
    this._matService.delColor(mat, color).subscribe(
      data => {
        this.materials[i].colors = data.material.colors;
        setTimeout(()=> {
          this._notifyService.setNote({
            styleClass: 'alert-success',
            heading: 'Success!',
            body: 'Color Deleted'
          });
          this._appService.hideLoader();
        }, 1000);
      }
    );
  }

  addMat() {
    this._appService.showLoader();
    this._matService.addMat(this.newMat).subscribe(
      data => {
        this.materials.unshift(data.material);
        this.newMat = null;
        setTimeout(()=> {
          this._notifyService.setNote({
            styleClass: 'alert-success',
            heading: 'Success!',
            body: 'Material Created'
          });
          this._appService.hideLoader();
        }, 1000);
      }
    );
  }

  addColor(mat, i) {
    this._appService.showLoader();
    this._matService.addColor(mat, this.newColor[mat.name]).subscribe(
      data => {
        this.materials[i].colors = data.material.colors;
        this.newColor[mat.name] = null;
        setTimeout(()=> {
          this._notifyService.setNote({
            styleClass: 'alert-success',
            heading: 'Success!',
            body: 'Color Created'
          });
          this._appService.hideLoader();
        }, 1000);
      }
    );
  }




}



// WEBPACK FOOTER //
// ./src/app/materials/materials.component.ts